import { render, staticRenderFns } from "./EditPartnerShopDialog.vue?vue&type=template&id=5a0b9c70&lang=pug&"
import script from "./EditPartnerShopDialog.vue?vue&type=script&lang=ts&"
export * from "./EditPartnerShopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditPartnerShopDialog.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports